import {AfterViewInit, ChangeDetectionStrategy, Component, TemplateRef, ViewChild, inject} from '@angular/core';
import {ButtonModule} from 'primeng/button';

import {TLabel, TranslatePipe} from '@mydeals/i18n';

import {ModalSeverity, ModalSize} from './modal-config.model';
import {ModalRef} from './modal-ref';

/** Payload consumed by {@link AlertModal}; built by `ModalService.alert()`. */
export interface AlertModalData {
  readonly message: TLabel;
  readonly messageParams?: Record<string, unknown>;
  readonly confirmLabel: TLabel;
}

/** Public options for `ModalService.alert()`. Only `title` and `message` are required. */
export interface AlertOptions {
  readonly title: TLabel;
  readonly message: TLabel;
  readonly messageParams?: Record<string, unknown>;
  readonly icon?: string;
  readonly severity?: ModalSeverity;
  readonly confirmLabel?: TLabel;
  readonly size?: ModalSize;
}

/** Acknowledge-only dialog: a message and a single dismiss button, no choice to make. */
@Component({
  selector: 'crm-alert-modal',
  imports: [ButtonModule, TranslatePipe],
  templateUrl: './alert-modal.html',
  styleUrl: './alert-modal.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AlertModal implements AfterViewInit {
  private readonly modalRef = inject<ModalRef<void, AlertModalData>>(ModalRef);

  @ViewChild('footerTpl', {static: true}) footerTpl!: TemplateRef<unknown>;

  protected readonly data = this.modalRef.data!;

  ngAfterViewInit(): void {
    this.modalRef.setFooter(this.footerTpl);
  }

  dismiss(): void {
    this.modalRef.close();
  }
}
